// O prêmio do cartão chega ao cliente como um cupom guardado na conta dele
// (backend/api/v1/fidelidade/premio.py). Aqui ele vira o formato de cupom que o
// checkout do cardápio já entende, com `_premio` para as regras próprias.

export const premioComoCupom = (p, somaCashback) => ({
  code: p.codigo,
  description: `🎁 Prêmio do cartão fidelidade: ${p.texto}`,
  discount_type: p.tipo === "desconto_pct" ? "percentage" : p.tipo === "frete" ? "free_delivery" : "fixed",
  discount_value: Number(p.valor || 0),
  min_order_value: 0,
  valid_until: p.vence_em,
  _premio: { tipo: p.tipo, product_id: p.product_id, size_id: p.size_id, texto: p.texto, somaCashback: !!somaCashback },
});

/** O prêmio de produto só vale com o produto (ou o tamanho de pizza) na sacola. */
export const premioCabeNaSacola = (cupom, sacola) => {
  const p = cupom?._premio;
  if (!p || (p.tipo !== "produto" && p.tipo !== "pizza")) return true;
  return (sacola || []).some((i) => (p.tipo === "pizza"
    ? String(i?.pizza?.size_id || "") === String(p.size_id)
    : String(i?.id || i?.product_id || "") === String(p.product_id)));
};

export const vencimento = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "" : d.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" });
};
